import * as React from "react";
import { Chip, Div, Label, Touchable } from "@grassrootly/rn-core";
import { Image } from "react-native";
import GamePlayers from "../game-attendees/GamePlayers";
import { IGame, DEFAULT_TEAMS } from "@grassrootly/api";
import { GameType } from "../../../screens/new-game/NewGame.types";
import { images } from "../../../layout/assets";
import { NavigationProp } from "@react-navigation/native";
import { MainStackParamList } from "../../../navigation/Navigation.types";

interface GameLineupsProps {
  game: IGame;
  showPoints: boolean;
  navigation?: NavigationProp<MainStackParamList>;
}

export default function GameLineups({ game, showPoints, navigation }: GameLineupsProps) {
  const [selectedTeam, setSelectedTeam] = React.useState<"HOST" | "VISITOR">("HOST");

  // Determine if we should show team selector buttons
  const showTeamSelector = game.game_type === GameType.TRAINING || game.game_type === GameType.ORGANIZATION_MATCH;

  // Get team names based on game type
  const hostTeamName = game.host_team_name || "Beli";
  const visitorTeamName = game.visitor_team_name || "Markeri";

  // Filter players by selected team
  const filteredPlayers = showTeamSelector
    ? game.attendees.filter((a) => a.team === DEFAULT_TEAMS[selectedTeam])
    : game.attendees;

  return (
    <Div classNames={["flex1"]}>
      {/* Team selector buttons - only for TRAINING and ORGANIZATION_MATCH */}
      {showTeamSelector && (
        <Div classNames={["flexRow", "gap8", "p16", "bgNeutralDarkerDark", "justifyContentCenter"]}>
          {/* Host Team Button */}
          <Touchable onPress={() => setSelectedTeam("HOST")}>
            <Div
              classNames={[
                "flexRow",
                "alignItemsCenter",
                "gap8",
                "ph16",
                "pv8",
                "rounded",
                selectedTeam === "HOST" ? "bgPrimaryMain" : "bgNeutralDarkerContrast",
              ]}
            >
              <Image
                source={game.host_team_logo ? { uri: game.host_team_logo } : images.whiteTeamLogo}
                style={{ width: 20, height: 20, borderRadius: 10 }}
                resizeMode="cover"
              />
              <Label
                classNames={[
                  "l4Regular",
                  selectedTeam === "HOST" ? "colorNeutralLighterLight" : "colorSecondaryContrast",
                ]}
              >
                {hostTeamName}
              </Label>
            </Div>
          </Touchable>

          {/* Visitor Team Button */}
          <Touchable onPress={() => setSelectedTeam("VISITOR")}>
            <Div
              classNames={[
                "flexRow",
                "alignItemsCenter",
                "gap8",
                "ph16",
                "pv8",
                "rounded",
                selectedTeam === "VISITOR" ? "bgPrimaryMain" : "bgNeutralDarkerContrast",
              ]}
            >
              <Image
                source={game.visitor_team_logo ? { uri: game.visitor_team_logo } : images.blackTeamLogo}
                style={{ width: 20, height: 20, borderRadius: 10 }}
                resizeMode="cover"
              />
              <Label
                classNames={[
                  "l4Regular",
                  selectedTeam === "VISITOR" ? "colorNeutralLighterLight" : "colorSecondaryContrast",
                ]}
              >
                {visitorTeamName}
              </Label>
            </Div>
          </Touchable>
        </Div>
      )}

      {/* Player list */}
      <GamePlayers attendees={filteredPlayers} showPoints={showPoints} navigation={navigation} />
    </Div>
  );
}
